export default __webpack_public_path__ + "static/media/icon-patient-tableau.16cc7e20.svg";